import React from "react"

const QpRightPanel = ({ fillColor, strokeColor }) => (
  <g id="right-panel">
    <path fill={fillColor} d="M334.286 350.354c-30.2 1.2-83.399-6-127.599-13.3 2.8 29.8 9.7 106.8 11.4 149.1 1.9 47.3 7.8 132.1 14.5 152.2 5.6 2 8.799 3.1 8.799 3.1s116 21 133-11 20-52 20-67v-157l2.5-63.8c-.1.1-6.3 5.4-62.6 7.7Z" />
    <path stroke={strokeColor} d="M334.286 350.354c-30.2 1.2-83.399-6-127.599-13.3 2.8 29.8 9.7 106.8 11.4 149.1 1.9 47.3 7.8 132.1 14.5 152.2 5.6 2 8.799 3.1 8.799 3.1s116 21 133-11 20-52 20-67v-157l2.5-63.8c-.1.1-6.3 5.4-62.6 7.7Z" strokeWidth="3" strokeMiterlimit="10"/>
  </g>
)

export default QpRightPanel
